import { createFileRoute } from '@tanstack/react-router';
import { buildHead } from '../../../../utils/seo';

export const Route = createFileRoute('/_layout/products/agent/how-it-works')({
  head: () => buildHead('/products/agent/how-it-works'),
});

